import React, { useContext } from 'react';
import { 
  Box, 
  Grid, 
  Heading, 
  Page, 
  PageContent, 
  PageHeader, 
  ResponsiveContext, 
  Text 
} from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid'; 
import { RulesAudit } from '../../components/demo/RulesAudit';
import { CostByYear } from '../../components/demo/CostByYear';
import HomeTilesCSV from '../../data/home/HomeTiles.csv';

export const Home = () => {
  const size = useContext(ResponsiveContext);
  const isMobile = ['xsmall', 'small'].includes(size);

  // Responsive Grid Logic: 
  // Object notation for columns is more stable in Grommet for stacking
  const gridColumns = isMobile 
    ? { count: 1, size: 'auto' } 
    : { count: 2, size: 'auto' };

  return (
    <Page flex="grow" background="transparent">
      {/* HEADER SECTION */}
      <Box background="transparent" margin={{ top: 'none' }} pad={{ bottom: '0px' }}>
        <Box margin={{ top: 'none', left: 'xlarge' }}>
          <PageHeader
            pad={{ top: '0px', bottom: '40px' }}
            title={
              <Text color="text-strong" size="xlarge" weight="bold">
                Welcome
              </Text>
            }
            size="medium"
          />
        </Box>
      </Box>

      {/* CONTENT SECTION */}
      <PageContent 
        flex="grow" 
        background="transparent" 
        style={{ width: '100%' }}
      >
        <Heading 
          level={2} 
          size="small" 
          weight="bold" 
          color="text-strong" 
          margin={{ top: '0px', bottom: 'xsmall' }}
        >
          Example Insights:
        </Heading>

        <Grid 
          columns={gridColumns} 
          rows="auto" 
          gap="medium" 
          margin={{ vertical: 'medium' }}
        >
          <RulesAudit period="Last Year" />
          <CostByYear period="Lifetime" />
        </Grid>

        <DashboardGrid filePath={HomeTilesCSV} />
      </PageContent> 
    </Page>
  );
};